// bill_subsystem_v1: bill_users management (owner only)
import React, { useState, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import API from '../api';

export default function BillUsers() {
  const ctx = useOutletContext();
  const user = ctx && ctx.user;
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ email: '', password: '', name: '', role: 'admin' });
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const [permUser, setPermUser] = useState(null); /* FinancePermModal */

  const isOwner = user && user.bill_role === 'owner';

  function load() {
    setLoading(true);
    API.get('/api/bill/users')
      .then(function (r) { setUsers(r.data || []); })
      .catch(function () {})
      .finally(function () { setLoading(false); });
  }

  useEffect(function () { load(); }, []);

  function resetForm() {
    setForm({ email: '', password: '', name: '', role: 'admin' });
    setEditing(null);
    setShowForm(false);
    setError('');
  }

  function openCreate() { resetForm(); setShowForm(true); }

  function openEdit(u) {
    setEditing(u);
    setForm({ email: u.email, password: '', name: u.name, role: u.role });
    setShowForm(true);
    setError('');
  }

  async function handleSave() {
    setError('');
    if (!form.email || !form.name) { setError('กรอก email และ name'); return; }
    if (!editing && !form.password) { setError('กรุณากำหนดรหัสผ่าน'); return; }
    if (form.password && form.password.length < 6) { setError('รหัสผ่านอย่างน้อย 6 ตัว'); return; }
    setSaving(true);
    try {
      if (editing) {
        var payload = { name: form.name, role: form.role };
        if (form.password) payload.password = form.password;
        await API.put('/api/bill/users/' + editing.id, payload);
      } else {
        /* billperm_autoopen_v1: สร้างเสร็จ เด้ง modal สิทธิ์ทันที (เฉพาะ non-owner) */
        var rNew = await API.post('/api/bill/users', form);
        resetForm();
        load();
        var nu = rNew && rNew.data && rNew.data.id ? rNew.data : null;
        if (nu && nu.role !== 'owner') { setPermUser(nu); }
        setSaving(false);
        return;
      }
      resetForm();
      load();
    } catch (err) {
      setError((err.response && err.response.data && err.response.data.error) || 'บันทึกไม่สำเร็จ');
    } finally {
      setSaving(false);
    }
  }

  async function handleToggle(u) {
    try {
      await API.put('/api/bill/users/' + u.id, { is_active: !u.is_active });
      load();
    } catch (err) {
      alert((err.response && err.response.data && err.response.data.error) || 'อัปเดตไม่สำเร็จ');
    }
  }

  async function handleDelete(u) {
    if (!window.confirm('ลบ ' + u.email + '?')) return;
    try {
      await API.delete('/api/bill/users/' + u.id);
      load();
    } catch (err) {
      alert((err.response && err.response.data && err.response.data.error) || 'ลบไม่สำเร็จ');
    }
  }

  function roleBadge(role) {
    var colors = {
      owner: { bg: '#fef3c7', fg: '#b45309' },
      admin: { bg: '#dbeafe', fg: '#1d4ed8' },
      accountant: { bg: '#ecfdf5', fg: '#047857' },
    };
    var c = colors[role] || colors.admin;
    return <span style={{ background: c.bg, color: c.fg, padding: '2px 8px', borderRadius: 8, fontSize: 11, fontWeight: 600 }}>{role}</span>;
  }

  if (!isOwner) {
    return (
      <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 12, padding: 20, color: '#dc2626' }}>
        ⚠️ หน้านี้สำหรับ <strong>owner</strong> เท่านั้น
      </div>
    );
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h1 style={{ margin: 0, fontSize: 22 }}>ผู้ใช้งานระบบบิล</h1>
        <button onClick={openCreate} style={{ background: '#10b981', color: 'white', border: 'none', padding: '8px 16px', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600 }}>+ เพิ่มผู้ใช้</button>
      </div>
      {loading ? (
        <div style={{ textAlign: 'center', padding: 40, color: '#94a3b8' }}>กำลังโหลด...</div>
      ) : (
        <div style={{ background: 'white', borderRadius: 12, border: '1px solid #e2e8f0', overflow: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
            <thead>
              <tr style={{ background: '#f8fafc', textAlign: 'left' }}>
                <th style={{ padding: 12 }}>Email</th>
                <th style={{ padding: 12 }}>ชื่อ</th>
                <th style={{ padding: 12 }}>Role</th>
                <th style={{ padding: 12 }}>สถานะ</th>
                <th style={{ padding: 12 }}>Login ล่าสุด</th>
                <th style={{ padding: 12, textAlign: 'right' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map(function (u) {
                return (
                  <tr key={u.id} style={{ borderTop: '1px solid #f1f5f9' }}>
                    <td style={{ padding: 12 }}>{u.email}</td>
                    <td style={{ padding: 12 }}>{u.name}</td>
                    <td style={{ padding: 12 }}>{roleBadge(u.role)}</td>
                    <td style={{ padding: 12 }}>
                      <span style={{ color: u.is_active ? '#10b981' : '#94a3b8', fontWeight: 600, fontSize: 12 }}>
                        {u.is_active ? '✓ ใช้งาน' : '✗ ปิด'}
                      </span>
                    </td>
                    <td style={{ padding: 12, fontSize: 12, color: '#64748b' }}>
                      {u.last_login_at ? new Date(u.last_login_at).toLocaleString('th-TH') : '-'}
                    </td>
                    <td style={{ padding: 12, textAlign: 'right' }}>
                      <button onClick={function () { openEdit(u); }} style={{ background: 'none', border: '1px solid #e2e8f0', padding: '4px 10px', borderRadius: 6, fontSize: 12, marginRight: 4, cursor: 'pointer' }}>แก้ไข</button>
                      <button onClick={function () { handleToggle(u); }} style={{ background: 'none', border: '1px solid #e2e8f0', padding: '4px 10px', borderRadius: 6, fontSize: 12, marginRight: 4, cursor: 'pointer' }}>{u.is_active ? 'ปิด' : 'เปิด'}</button>
                      {u.role !== 'owner' && (
                        <button onClick={function () { setPermUser(u); }} style={{ background: '#ecfdf5', border: '1px solid #a7f3d0', color: '#059669', padding: '4px 10px', borderRadius: 6, fontSize: 12, marginRight: 4, cursor: 'pointer' }}>สิทธิ์การเงิน</button>
                      )}
                      {u.id !== user.id && (
                        <button onClick={function () { handleDelete(u); }} style={{ background: 'none', border: '1px solid #fecaca', color: '#dc2626', padding: '4px 10px', borderRadius: 6, fontSize: 12, cursor: 'pointer' }}>ลบ</button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      {showForm && (
        <div onClick={function () { if (!saving) resetForm(); }} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, zIndex: 100 }}>
          <div onClick={function (e) { e.stopPropagation(); }} style={{ background: 'white', borderRadius: 14, padding: 24, maxWidth: 480, width: '100%' }}>
            <h3 style={{ margin: '0 0 16px' }}>{editing ? 'แก้ไขผู้ใช้' : 'เพิ่มผู้ใช้'}</h3>
            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 13, color: '#475569' }}>Email</label>
              <input value={form.email} onChange={function (e) { setForm(Object.assign({}, form, { email: e.target.value })); }} disabled={!!editing} type="email" style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 14, marginTop: 4, boxSizing: 'border-box' }} />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 13, color: '#475569' }}>ชื่อ</label>
              <input value={form.name} onChange={function (e) { setForm(Object.assign({}, form, { name: e.target.value })); }} style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 14, marginTop: 4, boxSizing: 'border-box' }} />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 13, color: '#475569' }}>รหัสผ่าน {editing && '(เว้นว่างถ้าไม่เปลี่ยน)'}</label>
              <input value={form.password} onChange={function (e) { setForm(Object.assign({}, form, { password: e.target.value })); }} type="password" placeholder={editing ? '••••••••' : 'อย่างน้อย 6 ตัว'} style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 14, marginTop: 4, boxSizing: 'border-box' }} />
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ fontSize: 13, color: '#475569' }}>Role</label>
              <select value={form.role} onChange={function (e) { setForm(Object.assign({}, form, { role: e.target.value })); }} style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 14, marginTop: 4, fontFamily: 'inherit' }}>
                <option value="owner">owner</option>
                <option value="admin">admin</option>
                <option value="accountant">accountant</option>
              </select>
            </div>
            {error && <div style={{ background: '#fef2f2', color: '#dc2626', padding: 10, borderRadius: 8, fontSize: 13, marginBottom: 12 }}>⚠️ {error}</div>}
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={resetForm} disabled={saving} style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid #e2e8f0', background: 'white', cursor: 'pointer', fontSize: 14 }}>ยกเลิก</button>
              <button onClick={handleSave} disabled={saving} style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: saving ? '#94a3b8' : '#10b981', color: 'white', cursor: saving ? 'not-allowed' : 'pointer', fontSize: 14, fontWeight: 600 }}>{saving ? 'กำลังบันทึก...' : 'บันทึก'}</button>
            </div>
          </div>
        </div>
      )}
      {permUser && <FinancePermModal user={permUser} onClose={function () { setPermUser(null); }} />}
    </div>
  );
}

// ===== FinancePermModal: owner ตั้งสิทธิ์การเงินของ admin =====
/* billperm_ui_v1: เมนูทั้งระบบ (บิล + การเงิน) — '__GROUP__' = แถวหัวข้อหมวด */
var FIN_VIEWONLY = ['summary', 'dashboard'];
var FIN_RESOURCES = [
  ['__GROUP__', 'ระบบบิล'],
  ['dashboard', 'แดชบอร์ด'], ['invoices', 'ใบแจ้งหนี้'], ['customers', 'ลูกค้า'], ['products', 'สินค้า'], ['channels', 'ช่องทาง'],
  ['__GROUP__', 'ระบบการเงิน'],
  ['transactions', 'รายรับ-รายจ่าย'], ['accounts', 'บัญชี'], ['businesses', 'ธุรกิจ'], ['categories', 'จัดการรายการ'], ['summary', 'สรุปการเงิน']
];
function FinancePermModal(props) {
  const [perms, setPerms] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');
  useEffect(function () {
    setLoading(true);
    API.get('/api/finance/permissions/users').then(function (r) {
      var found = (r.data || []).find(function (x) { return x.id === props.user.id; });
      var p = {};
      FIN_RESOURCES.forEach(function (rs) { var k = rs[0]; if (k === '__GROUP__') return; p[k] = (found && found.perms && found.perms[k]) || { view: false, edit: false, delete: false }; });
      setPerms(p);
    }).catch(function () { setErr('โหลดสิทธิ์ไม่สำเร็จ'); }).finally(function () { setLoading(false); });
  }, [props.user.id]);
  var toggle = function (res, act) { setPerms(function (prev) { var np = Object.assign({}, prev); np[res] = Object.assign({}, np[res]); np[res][act] = !np[res][act]; if (act === 'view' && !np[res][act]) { np[res].edit = false; np[res].delete = false; } if ((act === 'edit' || act === 'delete') && np[res][act]) { np[res].view = true; } return np; }); };
  /* billperm_selectall_v1: เลือก/ล้างทั้งหมด (scope: all/bill/finance, act: view/edit/delete) */
  var GRP_BILL = ['dashboard', 'invoices', 'customers', 'products', 'channels'];
  var GRP_FIN = ['transactions', 'accounts', 'businesses', 'categories', 'summary'];
  var resList = function (scope) { return scope === 'bill' ? GRP_BILL : scope === 'finance' ? GRP_FIN : GRP_BILL.concat(GRP_FIN); };
  var setBulk = function (scope, act, val) { setPerms(function (prev) { var np = Object.assign({}, prev); resList(scope).forEach(function (k) { np[k] = Object.assign({}, np[k]); var vo = (FIN_VIEWONLY.indexOf(k) !== -1); if (act === 'view') { np[k].view = val; if (!val) { np[k].edit = false; np[k].delete = false; } } else if (!vo) { np[k][act] = val; if (val) np[k].view = true; } }); return np; }); };
  var btnSA = { padding: '4px 10px', borderRadius: 6, border: '1px solid #e2e8f0', background: '#fff', color: '#475569', cursor: 'pointer', fontSize: 11 };
  var save = function () {
    setSaving(true); setErr('');
    API.put('/api/finance/permissions/users/' + props.user.id, { perms: perms })
      .then(function () { props.onClose(); })
      .catch(function (e) { setErr((e.response && e.response.data && e.response.data.error) || 'บันทึกไม่สำเร็จ'); })
      .finally(function () { setSaving(false); });
  };
  return (
    <div onClick={props.onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100, padding: 16 }}>
      <div onClick={function (e) { e.stopPropagation(); }} style={{ background: '#fff', borderRadius: 14, padding: 22, width: '100%', maxWidth: 460, maxHeight: '90vh', overflowY: 'auto' }}>
        <h3 style={{ margin: '0 0 4px', fontSize: 16 }}>สิทธิ์การเงิน</h3>
        <div style={{ fontSize: 13, color: '#64748b', marginBottom: 16 }}>{props.user.name} ({props.user.email})</div>
        {loading ? <div style={{ padding: 30, textAlign: 'center', color: '#94a3b8' }}>กำลังโหลด...</div> : (
          <div>
          <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
            <button onClick={function () { setBulk('all', 'view', true); setBulk('all', 'edit', true); setBulk('all', 'delete', true); }} style={Object.assign({}, btnSA, { background: '#ecfdf5', borderColor: '#a7f3d0', color: '#059669', fontWeight: 600 })}>เลือกทั้งหมด</button>
            <button onClick={function () { setBulk('all', 'view', false); }} style={btnSA}>ล้างทั้งหมด</button>
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead><tr style={{ background: '#f8fafc' }}>
              <th style={{ padding: '8px 10px', textAlign: 'left', fontSize: 12, color: '#64748b' }}>เมนู</th>
              {/* billperm_selectall_v1: checkbox หัวคอลัมน์ */}
              <th style={{ padding: '8px 6px', fontSize: 12, color: '#64748b' }}>อ่าน<br/><input type="checkbox" title="เลือกอ่านทั้งหมด" checked={resList('all').every(function (k) { return perms[k] && perms[k].view; })} onChange={function (e) { setBulk('all', 'view', e.target.checked); }} /></th>
              <th style={{ padding: '8px 6px', fontSize: 12, color: '#64748b' }}>แก้ไข<br/><input type="checkbox" title="เลือกแก้ไขทั้งหมด" checked={resList('all').filter(function (k) { return FIN_VIEWONLY.indexOf(k) === -1; }).every(function (k) { return perms[k] && perms[k].edit; })} onChange={function (e) { setBulk('all', 'edit', e.target.checked); }} /></th>
              <th style={{ padding: '8px 6px', fontSize: 12, color: '#64748b' }}>ลบ<br/><input type="checkbox" title="เลือกลบทั้งหมด" checked={resList('all').filter(function (k) { return FIN_VIEWONLY.indexOf(k) === -1; }).every(function (k) { return perms[k] && perms[k].delete; })} onChange={function (e) { setBulk('all', 'delete', e.target.checked); }} /></th>
            </tr></thead>
            <tbody>
              {FIN_RESOURCES.map(function (rs) {
                var k = rs[0]; var p = perms[k] || {}; var isViewOnly = (FIN_VIEWONLY.indexOf(k) !== -1);
                if (k === '__GROUP__') { var scope = (rs[1].indexOf('บิล') !== -1) ? 'bill' : 'finance'; return (<tr key={'g' + rs[1]}><td colSpan={4} style={{ padding: '12px 10px 4px', fontSize: 12, fontWeight: 700, color: '#0f172a', background: '#f8fafc' }}>{rs[1]}<button onClick={function () { setBulk(scope, 'view', true); setBulk(scope, 'edit', true); setBulk(scope, 'delete', true); }} style={{ marginLeft: 10, padding: '2px 8px', borderRadius: 5, border: '1px solid #a7f3d0', background: '#ecfdf5', color: '#059669', cursor: 'pointer', fontSize: 10, fontWeight: 600 }}>เลือกหมด</button><button onClick={function () { setBulk(scope, 'view', false); }} style={{ marginLeft: 5, padding: '2px 8px', borderRadius: 5, border: '1px solid #e2e8f0', background: '#fff', color: '#64748b', cursor: 'pointer', fontSize: 10 }}>ล้าง</button></td></tr>); }
                return (
                  <tr key={k} style={{ borderTop: '1px solid #f1f5f9' }}>
                    <td style={{ padding: '8px 10px', fontWeight: 500 }}>{rs[1]}</td>
                    <td style={{ padding: '8px 6px', textAlign: 'center' }}><input type="checkbox" checked={!!p.view} onChange={function () { toggle(k, 'view'); }} /></td>
                    <td style={{ padding: '8px 6px', textAlign: 'center' }}>{isViewOnly ? <span style={{ color: '#cbd5e1' }}>-</span> : <input type="checkbox" checked={!!p.edit} onChange={function () { toggle(k, 'edit'); }} />}</td>
                    <td style={{ padding: '8px 6px', textAlign: 'center' }}>{isViewOnly ? <span style={{ color: '#cbd5e1' }}>-</span> : <input type="checkbox" checked={!!p.delete} onChange={function () { toggle(k, 'delete'); }} />}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          </div>
        )}{/* billperm_selectall_done */}
        {err && <div style={{ background: '#fef2f2', color: '#dc2626', padding: 9, borderRadius: 8, fontSize: 13, marginTop: 12 }}>⚠️ {err}</div>}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
          <button onClick={props.onClose} style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid #e2e8f0', background: '#fff', cursor: 'pointer', fontSize: 14 }}>ยกเลิก</button>
          <button onClick={save} disabled={saving || loading} style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: '#10b981', color: '#fff', cursor: 'pointer', fontSize: 14, fontWeight: 600 }}>{saving ? 'บันทึก...' : 'บันทึก'}</button>
        </div>
      </div>
    </div>
  );
}
